import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Navbar = () => {
  const { FiTarget, FiX, FiMenu } = FiIcons;
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'NYC Local SEO', path: '/nyc-local-seo' },
    { name: 'GEO / AI', path: '/geo-ai-optimization' },
    { name: 'Industries', path: '/industries' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'glass-panel py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2">
            <SafeIcon icon={FiTarget} className="text-3xl text-blue-500" />
            <span className="text-xl font-bold text-white tracking-wider">NYC<span className="text-blue-500">SEO</span>.agency</span>
          </Link>
          <div className="hidden md:flex space-x-8 items-center">
            {navLinks.map((link) => (
              <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-blue-400 ${location.pathname === link.path ? 'text-blue-500' : 'text-slate-300'}`}>
                {link.name}
              </Link>
            ))}
            <Link to="/contact" className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full text-sm font-bold transition-all shadow-[0_0_15px_rgba(37,99,235,0.3)] hover:shadow-[0_0_25px_rgba(37,99,235,0.5)]">
              Free Audit
            </Link>
          </div>
          <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>
      {mobileMenuOpen && (
        <div className="md:hidden glass-panel absolute top-full left-0 w-full border-t border-slate-800 py-4 px-4 flex flex-col space-y-4 shadow-xl">
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} onClick={() => setMobileMenuOpen(false)} className="text-slate-300 hover:text-blue-400 font-medium">
              {link.name}
            </Link>
          ))}
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="bg-blue-600 text-white px-5 py-3 rounded-md text-center font-bold">
            Get Free SEO Audit
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;